import { render, staticRenderFns } from "./cardCitologias.vue?vue&type=template&id=4276ce5a&"
import script from "./cardCitologias.vue?vue&type=script&lang=js&"
export * from "./cardCitologias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports